import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './admin-panel.scss';

applyTranslations(require('./admin-panel.i18n.json'));

type Props = {
  children: React.ReactNode
}

const AdminPanel = ({ children }: Props) => (
  <section className="admin-panel">
    <header className="admin-panel__title">
      {__t('admin_panel.header')}
    </header>
    <section className="admin-panel__body">
      { children }
    </section>
  </section>
);

export default AdminPanel;
